export enum CommitteeMeetingFileTypeEnum {
  Agenda = 'Agenda',
  Minutes = 'Minutes',
}
